import SeatMap from './seat-map/theme';
import CancelOrder from './cancel-order/ui/theme';
import UpdatePageModal from './update-page-modal/ui/theme';
import StartCheckIn from './start-check-in/ui/theme';
import PriceGraph from './price-graph/ui/theme';
import * as UpsaleItem from './upsale/ui/UpsaleItem/UpsaleItem.css';
import Refund from './refund/theme';
import Exchange from './exchange/theme';
export default {
    SeatMap,
    Refund,
    Exchange,
    CancelOrder,
    UpdatePageModal,
    StartCheckIn,
    PriceGraph,
    Upsale: {
        UpsaleItem
    }
};
